export { RangeIndicator } from './range-indicator';
